export default "__VITE_ASSET__BVeaFA2j__"